export default {
  Faqs: '/carrier/faqs'
}
